import React from "react";
import { Row } from "reactstrap";

const ResourceFold = (props) => {
    const resourceList = [
        {
            point: "Prospectus",
            url: props?.mldAssetDetails?.productInfoMemorandum ? props.mldAssetDetails.productInfoMemorandum : "",
        },
        {
            point: "Rating Rationale",
            url: props?.mldAssetDetails?.ratingRationaleUrl ? props.mldAssetDetails.ratingRationaleUrl : "",
        },
        {
            point: "Company Financials",
            url: props?.mldAssetDetails?.companyFinancialsLink ? props.mldAssetDetails.companyFinancialsLink : "",
        },
    ]

    const handleRedirection = (url) => {
        if (url) {
            window.open(
            url,
            "_blank",
            "noopener"
            );
        } else {
            return
        }
      };
    return(
        <Row className="mx-0">
            <div ref={props?.refToLearn} />
            <div className={"resources " + (props?.fromBondsPage ? "bg-color-mld" : props?.fromMldPage ? "bg-color-mld" : "")}>
                <p className="title">More Resources</p>
                <div className="res-items">
                    {resourceList.map((item,index) =>(
                        <div className="item" onClick={() => handleRedirection(item.url)} key={index}>
                            <span class="mdi mdi-download" style={{padding: "0", width: "0", height: "0"}}></span><p className="ml-5 mb-0"><b>{item.point}</b></p>
                        </div>
                    ))}
                </div>
            </div>
        </Row>
    )
}

export default ResourceFold;
